package org.gymly.ui.admin

import org.gymly.model.AdminClient
import org.gymly.model.AdminClientStatus

/**
 * Clientes elegibles al seleccionar/buscar socio en Pagos, Órdenes y Alta masiva.
 * Solo filas de [AdminClient] activas — nunca personal/trabajadores.
 */
fun List<AdminClient>.forClientPicker(): List<AdminClient> =
    filter { it.status == AdminClientStatus.ACTIVE }

fun clientMatchesPickerSearch(client: AdminClient, query: String): Boolean {
    val q = query.trim().lowercase()
    if (q.isEmpty()) return true
    return client.firstName.lowercase().contains(q) ||
        client.lastName.lowercase().contains(q) ||
        client.fullName.lowercase().contains(q) ||
        (client.email?.lowercase()?.contains(q) == true) ||
        (client.docId?.lowercase()?.contains(q) == true)
}

fun filterClientsForPickerSearch(clients: List<AdminClient>, query: String, limit: Int = 12): List<AdminClient> {
    val q = query.trim()
    if (q.isEmpty()) return clients.take(limit)
    if (q.length < 2) return emptyList()
    return clients.filter { clientMatchesPickerSearch(it, q) }.take(limit)
}
